/* eslint-disable react/no-unstable-nested-components */

import { FatSelectItem, Select, SelectContent, SelectTrigger, SelectValue } from "components/ui/Select";
import classNames from "components/ui/classNames";
import useTheme from "components/ui/useTheme";
import { FormattedMessage, useIntl } from "react-intl";

interface SelectNumberOfRowsProps {
  value: string | number;
  disabled?: boolean;
  onChange: (numberOfRows: number) => void;
}
export default function SelectNumberOfRows({ value, onChange, disabled = false }: SelectNumberOfRowsProps) {
  const intl = useIntl();
  const theme = useTheme();
  const options = [5, 10, 15, 30, 45].map((numberOfrows) => ({
    value: String(numberOfrows),
    label: intl.formatMessage(
      {
        id: "dBYAFL",
        defaultMessage: "{numberOfRows} balanços",
        description: "Select option",
      },
      { numberOfRows: numberOfrows },
    ),
  }));

  return (
    <Select disabled={disabled} defaultValue={String(value)} onValueChange={(value) => onChange(parseInt(value, 10))}>
      <SelectTrigger
        className={classNames(
          "group inline-flex",
          "relative h-10 w-full items-center bg-white p-2 text-slate-600 lg:w-36",
          "rounded-xl border-slate-200 hover:border-slate-300",
          "hover:bg-slate-50 dark:hover:bg-slate-600",
          "dark:ring-slate-950",
          "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
          "focus-visible:outline-none",
          "focus-visible:ring-1 focus-visible:ring-offset-1",
          "focus-visible:ring-gray-100 focus-visible:ring-offset-gray-300",
          "focus-visible:border-transparent focus-visible:bg-gray-50 focus-visible:text-gray-600",
          "dark:focus-visible:ring-slate-950 dark:focus-visible:ring-offset-transparent",
          "disabled:pointer-events-none disabled:cursor-not-allowed",
        )}
      >
        <SelectValue asChild={true}>
          <div className="pointer-events-none flex w-full items-center justify-between space-x-2">
            <strong className={classNames("text-xs font-bold tracking-wide")}>
              <FormattedMessage
                id="dBYAFL"
                defaultMessage="{numberOfRows} balanços"
                description="Select option"
                values={{ numberOfRows: value }}
              />
            </strong>
          </div>
        </SelectValue>
      </SelectTrigger>

      <SelectContent
        side="top"
        sideOffset={20}
        className={classNames("rounded-xl border border-slate-200 text-sm", {
          "border-slate-900/80 bg-slate-900 text-slate-300 shadow-neutral-950/40": theme === "dark",
          dark: theme === "dark",
        })}
      >
        {options.map(({ value, label }) => {
          return (
            <FatSelectItem key={String(value)} className="cursor-pointer rounded-xl text-sm" value={String(value)}>
              <h4 className="py-1 text-xs font-bold text-slate-600 dark:text-slate-300">{label}</h4>
            </FatSelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
